export function parseApiListResponse<T>(
	response:
	  | ApiListResponse<T>
	  | ApiItemsListResponse<T>
	  | ApiResponse<ApiListResponse<T> | ApiItemsListResponse<T>>
	  | T[]
	  | null
	  | undefined,
): { data: T[], total: number } {
	if (Array.isArray(response)) {
		return {data: response, total: response.length};
	}

	if (response == null) {
		return {data: [], total: 0};
	}

	if (
		typeof response === "object"
		&& "data" in response
		&& "success" in response
		&& !("pagination" in response)
	) {
		return parseApiListResponse((response as ApiResponse<ApiListResponse<T> | ApiItemsListResponse<T>>).data);
	}

	if (
		typeof response === "object"
		&& "items" in response
		&& Array.isArray((response as ApiItemsListResponse<T>).items)
	) {
		const listResponse = response as ApiItemsListResponse<T>;
		const rows = listResponse.items ?? [];
		const total = listResponse.pagination?.total;
		return {
			data: rows,
			total: total != null && total > 0 ? total : rows.length,
		};
	}

	if (
		typeof response === "object"
		&& "data" in response
		&& Array.isArray((response as ApiListResponse<T>).data)
	) {
		const listResponse = response as ApiListResponse<T>;
		const rows = listResponse.data ?? [];
		const total = listResponse.pagination?.total;
		return {
			data: rows,
			total: total != null && total > 0 ? total : rows.length,
		};
	}

	return {data: [], total: 0};
}
